var _circle, _circle2, _path, _circle3, _g, _circle4, _circle5, _circle6, _path2, _path3, _path4, _path5, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNoProfilePhoto(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 76,
    height: 76,
    viewBox: "0 0 76 76",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4176_12466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "url(#paint0_linear_4176_12466)"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4176_12466)"
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 38,
    fill: "#181818"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8823 43.1025H46.0737L46.4546 43.1074C54.411 43.3102 60.8062 49.8557 60.8062 57.9062C60.8062 61.1715 60.8063 64.2597 60.7935 66.1865V66.1914C60.7935 67.8613 59.8574 69.3889 58.3765 70.1455L58.3628 70.1523C44.146 77.2888 30.2416 77.2283 16.5513 70.1826C16.5431 70.1779 16.5352 70.1723 16.5269 70.168C15.0679 69.4063 14.1463 67.8823 14.1499 66.2236V57.9062C14.1499 49.7284 20.7498 43.1026 28.8823 43.1025ZM37.478 8.5625C45.6055 8.56269 52.2103 15.1929 52.2104 23.3662C52.2104 31.5397 45.6056 38.1697 37.478 38.1699C29.3503 38.1699 22.7456 31.5398 22.7456 23.3662C22.7458 15.1927 29.3499 8.5625 37.478 8.5625Z",
    fill: "url(#paint1_radial_4176_12466)",
    stroke: "url(#paint2_linear_4176_12466)",
    strokeWidth: 1.47692
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37.2615,
    fill: "url(#paint3_radial_4176_12466)",
    stroke: "url(#paint4_linear_4176_12466)",
    strokeWidth: 1.47692
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_4176_12466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6136 39.3149H31.7208C25.3131 39.3149 20.1177 44.5348 20.1177 50.9717V57.2082C20.1145 58.6581 20.9194 59.9916 22.1978 60.659C22.1992 60.6597 22.2004 60.6606 22.2014 60.6617C22.2025 60.6628 22.2038 60.6637 22.2051 60.6644C32.6379 66.0383 43.2571 66.0836 54.0793 60.6511C54.0802 60.6506 54.0813 60.6504 54.0823 60.6504C54.0834 60.6504 54.0844 60.6501 54.0854 60.6496C55.3867 59.9888 56.208 58.6486 56.208 57.1856C56.2177 55.7382 56.2177 53.4197 56.2177 50.9717C56.2177 44.5344 51.0218 39.3149 44.6146 39.3149L44.6136 39.3149ZM38.1672 13.4102C31.7627 13.4102 26.5641 18.6332 26.5641 25.0669C26.5641 31.5006 31.7631 36.7236 38.1672 36.7236C44.5713 36.7236 49.7703 31.5006 49.7703 25.0669C49.7703 18.6332 44.5713 13.4102 38.1672 13.4102Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.6136 39.3149H31.7208C25.3131 39.3149 20.1177 44.5348 20.1177 50.9717V57.2082C20.1145 58.6581 20.9194 59.9916 22.1978 60.659C22.1992 60.6597 22.2004 60.6606 22.2014 60.6617C22.2025 60.6628 22.2038 60.6637 22.2051 60.6644C32.6379 66.0383 43.2571 66.0836 54.0793 60.6511C54.0802 60.6506 54.0813 60.6504 54.0823 60.6504C54.0834 60.6504 54.0844 60.6501 54.0854 60.6496C55.3867 59.9888 56.208 58.6486 56.208 57.1856C56.2177 55.7382 56.2177 53.4197 56.2177 50.9717C56.2177 44.5344 51.0218 39.3149 44.6146 39.3149L44.6136 39.3149ZM38.1672 13.4102C31.7627 13.4102 26.5641 18.6332 26.5641 25.0669C26.5641 31.5006 31.7631 36.7236 38.1672 36.7236C44.5713 36.7236 49.7703 31.5006 49.7703 25.0669C49.7703 18.6332 44.5713 13.4102 38.1672 13.4102Z",
    fill: "url(#paint5_linear_4176_12466)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.9575 57.1855C55.9575 58.5531 55.1908 59.805 53.9761 60.4238L53.9673 60.4277C43.2158 65.8247 32.6813 65.7789 22.3218 60.4434C22.319 60.4418 22.3168 60.439 22.314 60.4375C21.1187 59.8135 20.3647 58.5659 20.3677 57.209V50.9717C20.3677 44.6718 25.4526 39.5654 31.7212 39.5654H44.6138L44.6167 39.5645C50.8839 39.5656 55.9673 44.6721 55.9673 50.9717C55.9673 53.4199 55.9682 55.7372 55.9585 57.1836H55.9575V57.1855ZM38.1675 13.6602C44.4323 13.6603 49.52 18.7708 49.52 25.0674C49.5198 31.3638 44.4321 36.4735 38.1675 36.4736C31.9027 36.4736 26.8142 31.3638 26.814 25.0674C26.814 18.7707 31.9022 13.6602 38.1675 13.6602Z",
    stroke: "white",
    strokeWidth: 0.5
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4176_12466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 76,
    height: 76
  }, _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37,
    fill: "url(#paint6_radial_4176_12466)",
    stroke: "url(#paint7_linear_4176_12466)",
    strokeWidth: 2
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4176_12466)"
  }, _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 38,
    r: 37.3333,
    fill: "url(#paint8_radial_4176_12466)",
    stroke: "url(#paint9_linear_4176_12466)",
    strokeWidth: 1.33333
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4176_12466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 1,
    y: 1,
    width: 74,
    height: 74
  }, _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 38,
    cy: 37.9981,
    r: 36.5098,
    fill: "#D9D9D9"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4176_12466)"
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5391 50.0139L32.9704 59.7933L43.3087 59.9795L45.1714 57.8374L50.294 53.4599L54.1126 46.8472L51.2253 41.9109L42.5636 38.9305L33.6224 38.4648L23.191 42.7492L22.1665 46.1952L22.5391 50.0139Z",
    fill: "url(#paint10_linear_4176_12466)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.779 12.1333C28.5114 6.69791 35.5365 27.3512 34.3876 32.2113L27.6922 35.3187C26.9293 35.0853 12.5282 17.9335 20.779 12.1333ZM31.3665 33.0218C31.4756 29.6635 27.6001 16.8848 24.0115 18.9711C19.9916 21.3087 29.6727 33.3305 30.0217 33.5571L31.3665 33.0218Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8061 15.857C47.9236 14.5984 53.8243 13.7604 57.6402 20.443C59.9499 24.4878 58.1608 29.325 56.1109 30.0481C54.3735 30.6607 53.7573 30.1233 53.1001 29.782C52.8874 29.6715 52.6359 29.7486 52.4855 29.9353L48.891 34.398C48.7572 34.5641 48.5425 34.6428 48.3328 34.6037L41.1835 33.2689C40.903 33.2163 40.7022 32.9616 40.7116 32.6763C41.0868 21.2009 42.6756 17.7182 45.8061 15.857ZM46.8971 24.1241C46.8079 24.0361 46.671 24.0129 46.5709 24.0882C44.9247 25.328 43.669 31.7085 44.8013 32.3118C46.2518 33.0827 50.1724 28.51 50.5029 27.7943C50.5266 27.743 50.5034 27.6942 50.4633 27.6545L46.8971 24.1241Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_4176_12466",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 40,
    y: 14,
    width: 19,
    height: 21
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8057 15.8574C47.9228 14.5987 53.8246 13.7596 57.6409 20.4426C59.9505 24.4875 58.1605 29.3248 56.1106 30.0476C54.3729 30.6603 53.7571 30.1228 53.0998 29.7815C52.887 29.6711 52.6355 29.7481 52.4852 29.9348L48.8917 34.3977C48.7579 34.5638 48.5431 34.6433 48.3333 34.6043L41.1841 33.2695C40.9033 33.2171 40.7029 32.9614 40.7122 32.6759C41.0874 21.2009 42.6753 17.7187 45.8057 15.8574ZM46.8768 24.2904C46.7879 24.1992 46.6489 24.1746 46.5471 24.2511C44.904 25.487 43.669 31.7101 44.8008 32.3123C46.252 33.0835 50.0125 28.6328 50.3238 27.9328C50.3459 27.8828 50.323 27.8342 50.2849 27.795L46.8768 24.2904Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_4176_12466)"
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M49.0762 34.0648C48.9492 34.0489 44.7738 33.2071 42.6251 32.7727C42.5748 32.7625 42.5351 32.7269 42.5183 32.6785L39.7827 24.8095C39.7741 24.7848 39.7724 24.7583 39.7776 24.7328L41.1686 17.942C41.2042 17.7683 41.9421 17.7189 42.0257 17.8753C43.4663 20.5717 47.5915 25.011 50.525 27.7151C51.591 28.6978 52.4915 29.395 53.0577 29.759C53.1312 29.8063 53.1492 29.9065 53.0939 29.9741C51.9277 31.4 49.201 34.0804 49.0762 34.0648Z",
    fill: "url(#paint11_linear_4176_12466)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_dd_4176_12466)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9181 83.0252H55.1544H20.9009H16.1372C14.4358 83.0252 13.1882 82.5715 12.2808 81.5507C11.26 80.4165 10.9197 78.6017 11.3734 75.993C11.4869 74.8588 11.6003 73.838 11.7137 72.9306C12.7345 66.3522 13.1882 63.0629 14.4358 60.6811C15.9103 58.2992 18.0653 57.165 22.3754 54.7831C22.8864 54.4911 23.3974 54.1991 23.9688 53.8769C24.1586 53.7699 24.2535 53.7164 24.3102 53.6659C24.5686 53.4359 24.6262 53.0929 24.4571 52.7912C24.4199 52.7249 24.3422 52.6372 24.1867 52.4616C23.5328 51.7232 22.9811 50.9847 22.4888 50.2462C20.9233 47.5625 21.0115 45.0993 22.6446 42.9652C22.6617 42.9428 22.6703 42.9317 22.6764 42.9232C22.7037 42.8852 22.7232 42.852 22.743 42.8096C22.7474 42.8001 22.7523 42.7889 22.762 42.7665C28.0721 30.4786 32.4844 24.9531 37.4605 24.9531C42.3242 24.9531 47.3007 30.593 53.1774 42.7727C53.1876 42.7938 53.1927 42.8043 53.1973 42.8132C53.218 42.8533 53.2379 42.8844 53.2654 42.9201C53.2716 42.928 53.2801 42.9385 53.2973 42.9595C55.0436 45.0949 55.1318 47.5601 53.453 50.2462C53.0302 51.0073 52.4183 51.7683 51.7583 52.5293C51.6413 52.6642 51.5828 52.7317 51.5465 52.7979C51.3908 53.0816 51.4551 53.4527 51.6971 53.6675C51.7536 53.7177 51.8242 53.7575 51.9656 53.8372C52.5652 54.1752 53.148 54.4792 53.6799 54.7831C57.9899 57.165 60.1449 58.2992 61.506 60.6811C62.8671 63.0629 63.3207 66.3522 64.2281 72.9306C64.455 74.0649 64.5684 75.3125 64.7952 76.6736C65.0221 78.7152 64.6818 80.3031 63.661 81.4373C62.8671 82.4581 61.506 83.0252 59.9181 83.0252ZM53.5963 81.6641C53.7541 81.6641 53.833 81.6641 53.8987 81.6516C54.1839 81.5972 54.4069 81.3742 54.4613 81.0891C54.4738 81.0233 54.4738 80.9444 54.4738 80.7866V73.5283C54.4738 73.188 54.8141 72.8478 55.1544 72.8478C55.4946 72.8478 55.8349 73.188 55.8349 73.5283V80.7866C55.8349 80.9444 55.8349 81.0233 55.8474 81.0891C55.9018 81.3742 56.1248 81.5972 56.41 81.6516C56.4757 81.6641 56.5546 81.6641 56.7124 81.6641H59.9181C61.1657 81.6641 62.0731 81.3239 62.6402 80.6433C63.4342 79.736 63.661 78.4883 63.4342 76.9004C63.2073 75.5394 63.0939 74.1783 62.8671 73.0441C61.9597 66.6924 61.506 63.5166 60.3718 61.3616C59.1241 59.32 57.0825 58.1858 52.9993 56.0308C52.267 55.5731 51.5347 55.1893 50.6832 54.7004C50.5548 54.6267 50.4906 54.5899 50.4379 54.5699C50.1988 54.4794 49.9663 54.5124 49.762 54.666C49.7169 54.6998 49.6625 54.7562 49.5537 54.869C48.888 55.5592 48.1648 56.192 47.4417 56.8247C46.194 58.0724 44.9464 59.0932 44.039 60.2274C43.9256 60.3408 43.6987 60.4542 43.4719 60.4542C43.3585 60.4542 43.1316 60.3408 43.0182 60.2274C42.7913 60.0005 42.7913 59.5468 43.0182 59.32C44.039 58.1858 45.2866 57.0516 46.5343 55.9173C47.5551 54.8965 48.579 53.8726 49.4863 52.9653C49.4863 52.9653 49.4863 52.9653 49.4832 52.9684C52.4969 49.9548 54.5219 46.8313 52.3159 43.9223C52.3011 43.9029 52.2938 43.8932 52.2819 43.8791C52.2357 43.8243 52.1663 43.7653 52.1048 43.7284C52.089 43.719 52.0755 43.7118 52.0487 43.6976C47.4456 41.2555 42.6257 39.9248 38.0276 39.9248C33.3178 39.9248 28.6079 41.2553 23.8981 43.6969C23.8702 43.7114 23.8563 43.7186 23.84 43.7282C23.7767 43.7654 23.7052 43.8258 23.6578 43.8819C23.6456 43.8964 23.6382 43.9063 23.6232 43.926C21.4253 46.834 23.5597 49.956 26.572 52.9684C27.4794 53.8757 28.5002 54.8965 29.521 55.9173C30.7686 57.0516 32.0163 58.1858 33.0371 59.32C33.2474 59.5303 33.2627 59.9357 32.9926 60.1744C32.8838 60.2705 32.8295 60.3186 32.8285 60.3194C32.8021 60.3429 32.8429 60.3058 32.817 60.3299C32.8161 60.3307 32.8918 60.2597 32.8615 60.2881C32.7656 60.3781 32.6558 60.4542 32.4699 60.4542C32.3565 60.4542 32.1297 60.3408 32.0163 60.2274C30.9955 59.0932 29.8612 58.0724 28.6136 56.8247C27.8777 56.1808 27.1417 55.5368 26.4058 54.8324C26.2995 54.7307 26.2464 54.6798 26.201 54.6482C25.9941 54.5044 25.7684 54.4786 25.5344 54.572C25.4831 54.5926 25.4161 54.6323 25.2822 54.7119C24.4684 55.1953 23.6691 55.5767 22.9425 56.0308C18.8593 58.1858 16.8177 59.32 15.6835 61.3616C14.4358 63.5166 13.9821 66.6924 13.0748 73.0441C12.9613 74.0649 12.8479 75.0857 12.6211 76.2199C12.3942 78.3749 12.6211 79.8494 13.3016 80.6433C13.8687 81.3239 14.7761 81.6641 16.1372 81.6641H19.3428C19.5006 81.6641 19.5796 81.6641 19.6453 81.6516C19.9304 81.5972 20.1534 81.3742 20.2078 81.0891C20.2204 81.0233 20.2204 80.9444 20.2204 80.7866V73.5283C20.2204 73.188 20.5606 72.8478 20.9009 72.8478C21.2412 72.8478 21.5814 73.188 21.5814 73.5283V80.7866C21.5814 80.9444 21.5814 81.0233 21.594 81.0891C21.6484 81.3742 21.8714 81.5972 22.1565 81.6516C22.2222 81.6641 22.3011 81.6641 22.459 81.6641H53.5963Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M59.9181 83.0252H55.1544H20.9009H16.1372C14.4358 83.0252 13.1882 82.5715 12.2808 81.5507C11.26 80.4165 10.9197 78.6017 11.3734 75.993C11.4869 74.8588 11.6003 73.838 11.7137 72.9306C12.7345 66.3522 13.1882 63.0629 14.4358 60.6811C15.9103 58.2992 18.0653 57.165 22.3754 54.7831C22.8864 54.4911 23.3974 54.1991 23.9688 53.8769C24.1586 53.7699 24.2535 53.7164 24.3102 53.6659C24.5686 53.4359 24.6262 53.0929 24.4571 52.7912C24.4199 52.7249 24.3422 52.6372 24.1867 52.4616C23.5328 51.7232 22.9811 50.9847 22.4888 50.2462C20.9233 47.5625 21.0115 45.0993 22.6446 42.9652C22.6617 42.9428 22.6703 42.9317 22.6764 42.9232C22.7037 42.8852 22.7232 42.852 22.743 42.8096C22.7474 42.8001 22.7523 42.7889 22.762 42.7665C28.0721 30.4786 32.4844 24.9531 37.4605 24.9531C42.3242 24.9531 47.3007 30.593 53.1774 42.7727C53.1876 42.7938 53.1927 42.8043 53.1973 42.8132C53.218 42.8533 53.2379 42.8844 53.2654 42.9201C53.2716 42.928 53.2801 42.9385 53.2973 42.9595C55.0436 45.0949 55.1318 47.5601 53.453 50.2462C53.0302 51.0073 52.4183 51.7683 51.7583 52.5293C51.6413 52.6642 51.5828 52.7317 51.5465 52.7979C51.3908 53.0816 51.4551 53.4527 51.6971 53.6675C51.7536 53.7177 51.8242 53.7575 51.9656 53.8372C52.5652 54.1752 53.148 54.4792 53.6799 54.7831C57.9899 57.165 60.1449 58.2992 61.506 60.6811C62.8671 63.0629 63.3207 66.3522 64.2281 72.9306C64.455 74.0649 64.5684 75.3125 64.7952 76.6736C65.0221 78.7152 64.6818 80.3031 63.661 81.4373C62.8671 82.4581 61.506 83.0252 59.9181 83.0252ZM53.5963 81.6641C53.7541 81.6641 53.833 81.6641 53.8987 81.6516C54.1839 81.5972 54.4069 81.3742 54.4613 81.0891C54.4738 81.0233 54.4738 80.9444 54.4738 80.7866V73.5283C54.4738 73.188 54.8141 72.8478 55.1544 72.8478C55.4946 72.8478 55.8349 73.188 55.8349 73.5283V80.7866C55.8349 80.9444 55.8349 81.0233 55.8474 81.0891C55.9018 81.3742 56.1248 81.5972 56.41 81.6516C56.4757 81.6641 56.5546 81.6641 56.7124 81.6641H59.9181C61.1657 81.6641 62.0731 81.3239 62.6402 80.6433C63.4342 79.736 63.661 78.4883 63.4342 76.9004C63.2073 75.5394 63.0939 74.1783 62.8671 73.0441C61.9597 66.6924 61.506 63.5166 60.3718 61.3616C59.1241 59.32 57.0825 58.1858 52.9993 56.0308C52.267 55.5731 51.5347 55.1893 50.6832 54.7004C50.5548 54.6267 50.4906 54.5899 50.4379 54.5699C50.1988 54.4794 49.9663 54.5124 49.762 54.666C49.7169 54.6998 49.6625 54.7562 49.5537 54.869C48.888 55.5592 48.1648 56.192 47.4417 56.8247C46.194 58.0724 44.9464 59.0932 44.039 60.2274C43.9256 60.3408 43.6987 60.4542 43.4719 60.4542C43.3585 60.4542 43.1316 60.3408 43.0182 60.2274C42.7913 60.0005 42.7913 59.5468 43.0182 59.32C44.039 58.1858 45.2866 57.0516 46.5343 55.9173C47.5551 54.8965 48.579 53.8726 49.4863 52.9653C49.4863 52.9653 49.4863 52.9653 49.4832 52.9684C52.4969 49.9548 54.5219 46.8313 52.3159 43.9223C52.3011 43.9029 52.2938 43.8932 52.2819 43.8791C52.2357 43.8243 52.1663 43.7653 52.1048 43.7284C52.089 43.719 52.0755 43.7118 52.0487 43.6976C47.4456 41.2555 42.6257 39.9248 38.0276 39.9248C33.3178 39.9248 28.6079 41.2553 23.8981 43.6969C23.8702 43.7114 23.8563 43.7186 23.84 43.7282C23.7767 43.7654 23.7052 43.8258 23.6578 43.8819C23.6456 43.8964 23.6382 43.9063 23.6232 43.926C21.4253 46.834 23.5597 49.956 26.572 52.9684C27.4794 53.8757 28.5002 54.8965 29.521 55.9173C30.7686 57.0516 32.0163 58.1858 33.0371 59.32C33.2474 59.5303 33.2627 59.9357 32.9926 60.1744C32.8838 60.2705 32.8295 60.3186 32.8285 60.3194C32.8021 60.3429 32.8429 60.3058 32.817 60.3299C32.8161 60.3307 32.8918 60.2597 32.8615 60.2881C32.7656 60.3781 32.6558 60.4542 32.4699 60.4542C32.3565 60.4542 32.1297 60.3408 32.0163 60.2274C30.9955 59.0932 29.8612 58.0724 28.6136 56.8247C27.8777 56.1808 27.1417 55.5368 26.4058 54.8324C26.2995 54.7307 26.2464 54.6798 26.201 54.6482C25.9941 54.5044 25.7684 54.4786 25.5344 54.572C25.4831 54.5926 25.4161 54.6323 25.2822 54.7119C24.4684 55.1953 23.6691 55.5767 22.9425 56.0308C18.8593 58.1858 16.8177 59.32 15.6835 61.3616C14.4358 63.5166 13.9821 66.6924 13.0748 73.0441C12.9613 74.0649 12.8479 75.0857 12.6211 76.2199C12.3942 78.3749 12.6211 79.8494 13.3016 80.6433C13.8687 81.3239 14.7761 81.6641 16.1372 81.6641H19.3428C19.5006 81.6641 19.5796 81.6641 19.6453 81.6516C19.9304 81.5972 20.1534 81.3742 20.2078 81.0891C20.2204 81.0233 20.2204 80.9444 20.2204 80.7866V73.5283C20.2204 73.188 20.5606 72.8478 20.9009 72.8478C21.2412 72.8478 21.5814 73.188 21.5814 73.5283V80.7866C21.5814 80.9444 21.5814 81.0233 21.594 81.0891C21.6484 81.3742 21.8714 81.5972 22.1565 81.6516C22.2222 81.6641 22.3011 81.6641 22.459 81.6641H53.5963Z",
    fill: "url(#paint12_linear_4176_12466)",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4604 24.9951C39.8749 24.9951 42.3244 26.3947 44.9077 29.3232C47.4907 32.2514 50.2024 36.7024 53.1401 42.791C53.1501 42.8116 53.1557 42.8226 53.1606 42.832C53.1825 42.8743 53.2039 42.9077 53.2329 42.9453C53.2395 42.9538 53.2482 42.9657 53.2651 42.9863C54.1331 44.0478 54.5874 45.1891 54.6177 46.3975C54.6479 47.6063 54.2537 48.8866 53.4175 50.2246L53.4165 50.2256C52.996 50.9825 52.3868 51.7413 51.7271 52.502C51.6118 52.6349 51.5493 52.7064 51.5103 52.7773C51.3453 53.078 51.4131 53.4705 51.6694 53.6982C51.73 53.752 51.8054 53.7944 51.9448 53.873C52.2465 54.0431 52.5421 54.2035 52.8286 54.3594L53.6597 54.8193C57.9737 57.2034 60.1163 58.3327 61.4702 60.7021C62.1474 61.8874 62.6001 63.3001 62.9966 65.2402C63.3932 67.181 63.7332 69.6467 64.187 72.9365V72.9385C64.3002 73.5042 64.3851 74.0988 64.4702 74.7227C64.5551 75.345 64.6402 75.9968 64.7534 76.6768V76.6777C64.9795 78.7128 64.6399 80.2872 63.6304 81.4092L63.6284 81.4121C62.8444 82.4201 61.4969 82.9833 59.9185 82.9834H16.1372C14.444 82.9834 13.2092 82.5326 12.312 81.5234V81.5225C11.3669 80.4723 11.0064 78.8258 11.3384 76.4785L11.4146 76V75.9971C11.5279 74.8631 11.642 73.8425 11.7554 72.9355L11.7544 72.9346C12.2647 69.6459 12.6341 67.1809 13.0308 65.2402C13.4274 63.2995 13.852 61.886 14.4731 60.7002L14.4722 60.6992C15.7561 58.627 17.5581 57.5037 20.8765 55.6592L22.396 54.8193C22.907 54.5273 23.4184 54.2352 23.9897 53.9131C24.1769 53.8075 24.2774 53.7515 24.3384 53.6973C24.6113 53.4543 24.6723 53.0892 24.4937 52.7705C24.4537 52.6993 24.3717 52.6069 24.2183 52.4336C23.5658 51.6968 23.0144 50.9598 22.5229 50.2227C21.7442 48.8868 21.3785 47.6082 21.4087 46.4004C21.439 45.1922 21.8655 44.051 22.6772 42.9902C22.6942 42.9681 22.7039 42.9564 22.7104 42.9473C22.7392 42.9073 22.7599 42.8718 22.7808 42.8271C22.7855 42.817 22.7908 42.8052 22.8003 42.7832C25.4549 36.6403 27.8839 32.1911 30.269 29.2783C32.6539 26.3659 34.9901 24.9951 37.4604 24.9951ZM38.0278 39.8828C33.31 39.8828 28.5937 41.2162 23.8794 43.6602C23.8518 43.6745 23.8363 43.6821 23.8188 43.6924C23.7515 43.732 23.6759 43.7957 23.6255 43.8555C23.6128 43.8705 23.6048 43.8812 23.5903 43.9004C22.4809 45.3682 22.4651 46.8924 23.105 48.4238C23.7437 49.9523 25.0357 51.4912 26.5425 52.998L29.4927 55.9482C30.7407 57.0828 31.9872 58.2153 33.0063 59.3477L33.0073 59.3496C33.2011 59.5434 33.217 59.9211 32.9653 60.1436C32.9111 60.1915 32.8696 60.2268 32.8423 60.251H32.8384V60.252C32.8365 60.2537 32.8331 60.2575 32.8286 60.2617C32.7381 60.3457 32.6387 60.412 32.4702 60.4121C32.4237 60.4121 32.3459 60.3875 32.2622 60.3457C32.1802 60.3047 32.099 60.2515 32.0464 60.1992H32.0474C31.2813 59.348 30.4501 58.5597 29.5571 57.6934L28.6431 56.7949L28.6411 56.793L27.5376 55.8203C27.17 55.4911 26.8025 55.1545 26.4351 54.8027C26.3303 54.7025 26.2738 54.6482 26.2251 54.6143C26.0068 54.4624 25.766 54.4346 25.519 54.5332C25.4639 54.5552 25.3933 54.5973 25.2612 54.6758C24.8553 54.9169 24.4526 55.1331 24.0601 55.3457C23.8639 55.4519 23.6702 55.5577 23.48 55.665L22.9204 55.9951C19.0972 58.0129 17.0526 59.1408 15.8716 60.9668L15.647 61.3408C15.0199 62.424 14.5936 63.7623 14.2104 65.6211C13.8274 67.4798 13.4873 69.8631 13.0337 73.0381V73.0391C12.9203 74.06 12.807 75.0797 12.5806 76.2119H12.5796V76.2158C12.466 77.2952 12.4655 78.2064 12.5796 78.9482C12.6937 79.6901 12.923 80.266 13.27 80.6709V80.6699C13.8482 81.3637 14.7699 81.7061 16.1372 81.7061H19.3433C19.4987 81.7061 19.5824 81.7058 19.6528 81.6924C19.9548 81.6348 20.1909 81.3986 20.2485 81.0967C20.262 81.0262 20.2622 80.9419 20.2622 80.7861V73.5283C20.2622 73.3717 20.3407 73.2116 20.4624 73.0898C20.5842 72.9681 20.7443 72.8897 20.9009 72.8896C21.0575 72.8896 21.2176 72.9681 21.3394 73.0898C21.4611 73.2116 21.5396 73.3717 21.5396 73.5283V80.7861C21.5396 80.9419 21.5398 81.0262 21.5532 81.0967C21.6108 81.3986 21.847 81.6348 22.1489 81.6924C22.2194 81.7058 22.303 81.7061 22.4585 81.7061H53.5962C53.7521 81.7061 53.8362 81.7058 53.9067 81.6924C54.2086 81.6347 54.4449 81.3985 54.5024 81.0967C54.5159 81.0262 54.5151 80.9419 54.5151 80.7861V73.5283C54.5151 73.3717 54.5946 73.2116 54.7163 73.0898C54.838 72.9682 54.9983 72.8896 55.1548 72.8896C55.3111 72.8898 55.4707 72.9684 55.5923 73.0898C55.714 73.2116 55.7935 73.3717 55.7935 73.5283V80.7861C55.7935 80.9419 55.7927 81.0262 55.8062 81.0967C55.8637 81.3985 56.1001 81.6347 56.4019 81.6924C56.4724 81.7058 56.5565 81.7061 56.7124 81.7061H59.9185C61.173 81.706 62.0945 81.3633 62.6724 80.6699L62.6714 80.6689C63.4758 79.7489 63.7028 78.4882 63.4751 76.8945V76.8936C63.3618 76.214 63.277 75.5343 63.1919 74.8818C63.1069 74.2305 63.0212 73.6062 62.9077 73.0381H62.9087C62.4551 69.8628 62.1145 67.4797 61.7456 65.6211C61.4228 63.9948 61.0777 62.7675 60.6147 61.7607L60.4087 61.3418L60.4077 61.3398L60.1626 60.9648C59.058 59.3833 57.3753 58.3258 54.4565 56.7578L53.019 55.9941C52.2867 55.5366 51.5524 55.1513 50.7036 54.6641C50.5771 54.5914 50.5092 54.5527 50.4526 54.5312C50.2002 54.4356 49.9526 54.4707 49.7368 54.6328C49.6885 54.6692 49.6311 54.7287 49.5239 54.8398C48.8597 55.5284 48.1378 56.1601 47.4146 56.793L47.4126 56.7949C46.7894 57.4181 46.1666 57.9844 45.5845 58.5381C45.004 59.0902 44.4643 59.63 44.0093 60.1982C43.9031 60.3042 43.6869 60.412 43.4722 60.4121C43.4256 60.4121 43.347 60.3876 43.2632 60.3457C43.1809 60.3045 43.0998 60.2507 43.0474 60.1982C42.9435 60.0944 42.8901 59.9353 42.8901 59.7734C42.8902 59.6118 42.9437 59.4534 43.0474 59.3496L43.0493 59.3477C44.0684 58.2154 45.3141 57.0827 46.562 55.9482L46.564 55.9473C47.5847 54.9265 48.6078 53.9015 49.5151 52.9941C51.0214 51.4875 52.2859 49.9502 52.896 48.4219C53.5077 46.8895 53.4622 45.3654 52.3491 43.8975C52.3345 43.8782 52.3265 43.8674 52.314 43.8525C52.2648 43.7943 52.1919 43.7316 52.1265 43.6924C52.1095 43.6822 52.0945 43.6753 52.0679 43.6611C47.46 41.2165 42.6338 39.8829 38.0278 39.8828ZM32.7905 60.2979L32.7886 60.2998V60.2988C32.7888 60.2987 32.7894 60.2977 32.7905 60.2969V60.2979Z",
    stroke: "white",
    strokeWidth: 0.0833333
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_4176_12466",
    x: 20.1177,
    y: 13.4102,
    width: 40.1001,
    height: 55.3008,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4176_12466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4176_12466",
    result: "effect2_dropShadow_4176_12466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4176_12466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_dd_4176_12466",
    x: 11.1763,
    y: 24.9531,
    width: 54.3527,
    height: 58.737,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.333333,
    dy: 0.333333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.166667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_4176_12466"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.166667,
    dy: 0.166667
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.0833333
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_4176_12466",
    result: "effect2_dropShadow_4176_12466"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_4176_12466",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4176_12466",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1C1D1F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0F0F10"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_4176_12466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4783 42.0242) rotate(90) scale(34.2 24.0667)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4176_12466",
    x1: 37.4783,
    y1: 7.82422,
    x2: 37.4783,
    y2: 76.2242,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89BEFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_4176_12466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 38) rotate(90) scale(38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4176_12466",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89BEFE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_4176_12466",
    x1: 55.8824,
    y1: 29.616,
    x2: 39.1177,
    y2: 22.9102,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_4176_12466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 38) rotate(90) scale(38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D9DFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_4176_12466",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2D78FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#89BEFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_4176_12466",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38 38) rotate(90) scale(38)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#296CE6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#172F4D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_4176_12466",
    x1: 38,
    y1: 0,
    x2: 38,
    y2: 76,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1A365E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2561CA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_4176_12466",
    x1: 38.1395,
    y1: 38.4648,
    x2: 38.1861,
    y2: 50.2933,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.44
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1D4585",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_4176_12466",
    x1: 49.7615,
    y1: 27.2927,
    x2: 45.1378,
    y2: 32.9181,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_4176_12466",
    x1: 64.3638,
    y1: 43.2983,
    x2: 41.7011,
    y2: 31.3893,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#717171"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoProfilePhoto);
export default __webpack_public_path__ + "static/media/noProfilePhoto.e27fd942f9c89368a4d4a5e9c85315c6.svg";
export { ForwardRef as ReactComponent };